import React from "react";

import { Box, Tooltip } from "@mui/material";

import { ButtonVariant } from "Constant/button";

import StandartButton from "components/atoms/StandartButton";

const BUTTON_WIDTH = 132;

interface Props {
    scheduled: boolean;
    loading: boolean;
    onClick: () => void;
}

/**
 * Retry and Scheduled share one fixed slot so the label swap does not move
 * the control or the cells beside it.
 */
const LeadRetryButton = ({ scheduled, loading, onClick }: Props) => (
    <Tooltip
        title={scheduled ? "Lead retry process is scheduled." : ""}
        disableHoverListener={!scheduled}
    >
        <Box sx={{ width: BUTTON_WIDTH, flexShrink: 0, marginLeft: "auto" }}>
            <StandartButton
                variant={ButtonVariant.BLACK_OUTLINED}
                disabled={scheduled || loading}
                isLoading={loading}
                onClick={scheduled ? undefined : onClick}
                wrapperSx={{ width: "100%" }}
                sx={{ width: "100%" }}
            >
                {scheduled ? "Scheduled" : "Retry"}
            </StandartButton>
        </Box>
    </Tooltip>
);

export default LeadRetryButton;
